const productTabs = [
  {
    id: 0,
    name: "Products",
    singular: "Product",
    slug: "packages",
    indicatorStyle: {
      width: 75 + "px",
      left: 0 + "px"
    },
    modalName: "add-package",
    api: "packages"
  },
  {
    id: 1,
    name: "Categories",
    singular: "Category",
    slug: "categories",
    indicatorStyle: {
      width: 96 + "px",
      left: 109 + "px"
    },
    modalName: "add-category",
    api: "categories" //replace if necessary
  },
  {
    id: 3,
    name: "Locations",
    singular: "Location",
    slug: "locations",
    indicatorStyle: {
      width: 85 + "px",
      left: 236 + "px"
    },
    modalName: "add-location",
    api: "locations" //replace if necessary
  },
  {
    id: 4,
    name: "Inclusions",
    singular: "Inclusion",
    slug: "inclusions",
    indicatorStyle: {
      width: 82 + "px",
      left: 357 + "px"
    },
    modalName: "add-inclusion",
    api: "inclusions" //replace if necessary
  },
  {
    id: 5,
    name: "Terms",
    singular: "Term",
    slug: "terms",
    indicatorStyle: {
      width: 60 + "px",
      left: 471 + "px"
    },
    modalName: "add-term",
    api: "terms" //replace if necessary
  },
  {
    id: 6,
    name: "Schedules",
    singular: "Schedule",
    slug: "schedule",
    indicatorStyle: {
      width: 92 + "px",
      left: 560 + "px"
    },
    modalName: "add-schedule",
    modalParams: {
      width: 800
    },
    api: "schedules" //replace if necessary
  }
];

const memberTabs = [
  {
    id: 0,
    name: "All Members",
    singular: "Member",
    slug: "members",
    indicatorStyle: {
      width: 100 + "px",
      left: 0 + "px"
    },
    modalName: "add-member",
    api: "users"
  },
  {
    id: 1,
    name: "Groups",
    singular: "Group",
    slug: "groups",
    indicatorStyle: {
      width: 62 + "px",
      left: 138 + "px"
    },
    modalName: "add-company",
    api: "groups" //replace if necessary
  }
];

const bookingFilters = [
  {
    id: 0,
    label: "Period",
    filterType: "period",
    data: [
      {
        id: 0,
        label: "Current Month",
        value: "current-month"
      },
      {
        id: 1,
        label: "Last Month",
        value: "last-month"
      },
      {
        id: 2,
        label: "Custom Range",
        value: "custom"
      }
    ]
  },
  {
    id: 1,
    label: "Category",
    filterType: "category",
    data: [
      {
        id: "-1",
        label: "All",
        value: "all"
      }
    ]
  },
  {
    id: 2,
    label: "Product",
    filterType: "product",
    data: [
      {
        id: "-1",
        label: "All",
        value: "all"
      }
    ]
  }
];

const orderedDays = {
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
  Sun: 7
};

export { productTabs, memberTabs, bookingFilters, orderedDays };
